import { adminHttpClient } from '../../commons/adminHttpClient'

export type JobResponse = {
  id: string
  name: string
}

const getAllEnabledJobs = (): Promise<JobResponse[]> => {
  return adminHttpClient.get('Csi/ScheduledJobs', {})
}

export default getAllEnabledJobs
